import { MarkdownRenderer } from "src/base-components/MarkdownRenderer/MarkdownRenderer";

type ChatUserBubbleProps = {
  message: string;
  dataLoc?: string;
};

export const ChatUserBubble: React.FC<ChatUserBubbleProps> = ({
  message,
  dataLoc,
}) => {
  return (
    <div data-loc={dataLoc} className="rounded-lg bg-gray-100 p-2">
      <MarkdownRenderer content={message} />
    </div>
  );
};
